<script>
import { mapActions, mapGetters } from 'vuex';
import { find, filter } from 'lodash';
import SelectionLot from './selection_lot';
import CardsListItemArticleLot from './cards-list-item-article-lot';
import { parseISO } from 'date-fns/fp';
import { compareAsc } from 'date-fns/esm';
import { isFuture, isPast } from 'date-fns';

export default {
  name: 'Lots',
  components: {
    SelectionLot,
    CardsListItemArticleLot
  },
  props: {
    numBatiment: {
      type: String,
      default: null
    },
    numLot: {
      type: String,
      default: null
    },
    numExploitation: {
      type: String,
      default: null
    }
  },
  data: () => ({
    loading: true,
    lot: null,
    selectedPlan: null,

    // gestion modal
    modal: false,
    modalKey: 0,
    ligneCommande: null,
    quantiteMaxCommande: null,
    poidsTotal: null
  }),

  computed: {
    ...mapGetters({ tiers: 'user/tiers', lots: 'exploitation/lots', ref: 'referentiel/referentiel', lignesPanier: 'cart/cart' }),

    plans () {
      if (this.lot && this.lot.plansAlimentation) {
        // on filtre les plans vides
        const plans = this.lot.plansAlimentation.filter(p => p.tranches && p.tranches.filter(t => t.articles && t.articles.length).length);
        if (plans.length) {
          return plans
            .sort((a, b) => a.principal ? (b.principal ? compareAsc(parseISO(a.dateDebut), parseISO(b.dateDebut)) : -1) : 1)
            .map(plan => {
              let commandable = true;
              if (isFuture(parseISO(plan.dateDebut))) {
                commandable = false;
              }
              if (plan.dateFin && isPast(parseISO(plan.dateFin))) {
                commandable = false;
              }

              plan.commandable = commandable;

              return plan;
            });
        }
      }

      return [];
    }
  },
  async created () {
    if (!this.lots) {
      this.loadLots(this.tiers.numTiers).then(() => {
        this.init();
      }).finally(() => {
        this.loading = false;
      });
    } else {
      this.loading = false;
      this.init();
    }
  },
  methods: {
    ...mapActions({ loadLots: 'exploitation/loadLots', addLineToCart: 'cart/addLine' }),
    init () {
      const crit = {};
      if (parseInt(this.numExploitation)) {
        crit.numExploitation = parseInt(this.numExploitation);
      }
      if (parseInt(this.numBatiment)) {
        crit.numBatiment = parseInt(this.numBatiment);
      }
      const lots = filter(this.lots, crit);
      let lot = null;

      if (lots.length === 1) {
        lot = lots[0];
      } else if (lots.length > 1) {
        lot = find(lots, { numLot: this.numLot });
      }
      if (lot) {
        this.lot = lot;
      }
    },
    dedoublonnetranches (tranches) {
      const getKey = tranche => tranche.ageMini + '-' + tranche.ageMaxi + '-' + tranche.quantite;

      const _tranches = {};

      tranches.forEach(tranche => {
        const key = getKey(tranche);
        if (_tranches[key] === undefined) {
          _tranches[key] = Object.assign({}, tranche);
        } else {
          _tranches[key].articles = [].concat(_tranches[key].articles, tranche.articles);
        }
      });

      return Object.values(_tranches);
    },
    getArticles (planAlimentation) {
      if (this.lot && planAlimentation) {
        // mapping de lot:{planAlimentation:{tranches:[{articles:{}}]}} vers articles:[{tranche:{}}]

        const tranches = this.dedoublonnetranches(planAlimentation.tranches);

        const lot = this.lot;
        return tranches.map((tranche, indexTranche) => {
          // calcul des quantites
          tranche.quantiteCommandable = tranche.quantite * lot.nbAnimaux / 1000;
          tranche.articles.forEach(article => {
            article.quantiteCommandee = this.getQuantiteCommandee(article, lot);
          });
          tranche.quantiteCommandee = tranche.articles.reduce((t, i) => i.quantiteCommandee + t, 0);

          tranche.complete = tranche.quantiteCommandee >= tranche.quantiteCommandable * 0.8;
          tranche.tranchePrecedeenteComplete = indexTranche > 0 ? tranches[indexTranche - 1].complete : true;
          tranche.commandable = !tranche.complete && tranche.tranchePrecedeenteComplete;
          tranche.recommandee = !tranche.complete && tranche.tranchePrecedeenteComplete;

          return tranche.articles.map(article => {
            return Object.assign({}, article, {
              tranche: Object.assign({}, tranche, { articles: undefined })
            });
          });
        }).flat().sort((a, b) => a.tranche.ageMini - b.tranche.ageMini || a.tranche.ageMaxi - b.tranche.ageMaxi);
      } else {
        return [];
      }
    },
    getQuantiteCommandee (article, lot) {
      const quantitePanier = this.lignesPanier.filter(l => l.numLot === lot.numLot && l.numArticle === article.numArticle).reduce((t, l) => l.quantiteCommande + t, 0);

      return (lot.quantitesCommandees[article.numArticle] || 0) + quantitePanier;
    },

    // gestion commande
    commanderArticle (article) {
      const ligne = {
        libelleArticle: article.libelle,
        numArticle: article.numArticle,
        codeTypeArticle: article.codeTypeArticle,
        numBatiment: this.lot.numBatiment,
        numExploitation: this.lot.numExploitation,
        numLot: this.lot.numLot,
        codeUniteArticle: 'T',
        codeFiliere: this.lot.codeFiliere,
        numAdr: this.lot.numExploitation
      };

      this.ligneCommande = ligne;
      this.modal = true;
      this.modalKey++;
    },
    addToCart (ligne) {
      this.modal = false;
      this.quantiteMaxCommande = null;
      this.addLineToCart(ligne);
      setTimeout(() => {
        this.$dialog.confirm({ text: '<i aria-hidden="true" style="font-size:42px;" class="v-icon notranslate mdi mdi-check-circle-outline theme--light"></i><br/>Le produit a été ajouté à votre panier', actions: { continuer: { text: 'Continuer mes achats', flat: false }, panier: { text: 'Voir mon panier', color: 'primary', flat: false } } }).then(
          result => {
            if (result === 'panier') {
              this.$router.push({ name: 'main.catalog.cart' });
            }
          }
        );
      });
    }
  }
};
</script>

<template>
  <div>
    <h2>
      Lots et plans
      <CardsHelp
        :page="'LOTS-PLAN'"
        :niveau="'TITRE'"
      />
    </h2>
    <Loader
      v-if="loading"
      block
    />
    <div v-else-if="lots">
      <SelectionLot
        v-model="lot"
        :lots="lots"
      />
      <div v-if="lot">
        <div v-if="plans.length === 0">
          Il n’y a aucun plan d’alimentation renseigné pour votre lot en place.
        </div>
        <div v-else>
          <v-tabs
            v-show="plans.length > 1"
            v-model="selectedPlan"
          >
            <v-tab
              v-for="plan in plans"
              :key="plan.libelle"
            >
              {{ plan.libelle }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="selectedPlan">
            <v-tab-item
              v-for="plan of plans"
              :key="plan.libelle"
            >
              <div
                v-if="!plan.principal || !plan.commandable"
                class="mt-1"
              >
                <span>A partir du {{ plan.dateDebut | date }}</span>
                <span
                  v-if="plan.dateFin"
                  class="ml-2"
                >jusqu'au {{ plan.dateFin | date }}</span>
              </div>
              <CardsList
                :items="getArticles(plan)"
                :group-by="article=>(article.tranche)"
              >
                <template v-slot:groupTitle="{group}">
                  {{ group.ageMini }} à {{ group.ageMaxi }} jours
                </template>
                <template v-slot:groupFooter="{group, items}">
                  <div
                    class="mt-6 subtitle-1 primary--text"
                    :class="{'ml-8':!isMobile, 'ml-2':isMobile}"
                  >
                    <span class="mr-2 text-uppercase">
                      Total commandé :
                    </span>
                    <span class="no-wrap">
                      <strong>{{ items.reduce((t,i)=>i.quantiteCommandee+t , 0) | formatDecimal(0,3) }} t /
                        <span v-if="group.quantiteCommandable !== 0">
                          {{ group.quantiteCommandable | formatDecimal(3) }} t
                        </span>
                        <span v-else>-</span></strong>
                    </span>
                  </div>
                </template>
                <template v-slot:item="{item}">
                  <CardsListItemArticleLot
                    :item="item"
                    :class="{ 'tranche-recommandee':item.tranche.recommandee} "
                  >
                    <template v-slot:actions="{item}">
                      <!-- :disabled="!plan.commandable || !item.artCommandable || !item.tranche.commandable" -->
                      <v-btn
                        class="action-btn"
                        color="secondary"
                        :disabled="!plan.commandable || !item.artCommandable"
                        @click="commanderArticle(item)"
                      >
                        <v-icon>mdi-cart-outline</v-icon>
                      </v-btn>
                    </template>
                  </CardsListItemArticleLot>
                </template>
              </CardsList>
            </v-tab-item>
          </v-tabs-items>
        </div>
      </div>
      <v-dialog
        v-model="modal"
        transition="dialog-bottom-transition"
        :fullscreen="isMobile"
        persistent
        scrollable
      >
        <LineEdit
          v-if="modal"
          :key="modalKey"
          :line="ligneCommande"
          :disabled-fields="['BATIMENT']"
          is-ajout
          @cancel="modal=false"
          @validate="addToCart"
        />
      </v-dialog>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.v-tabs-items,
.v-tabs-item {
  background-color: transparent !important;
}

::v-deep .tranche-recommandee {
  position: relative;
  z-index: 50;
  * {
    z-index: 60;
  }
  &::before {
    z-index: 55;
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 20px;
    background-color: var(--v-primary-base);
    opacity: 0.5;
    clip-path: polygon(0 0, 0% 100%, 100% 50%);
  }
}
</style>
